import * as React from 'react';

interface IDataValueProps {
    label: string;
    value: string | number | null;
    unit?: string;
    status?: 'normal' | 'warning' | 'error' | 'success';
    icon?: React.ReactNode;
}

const DataValue: React.FunctionComponent<IDataValueProps> = ({ 
    label, 
    value, 
    unit, 
    status = 'normal',
    icon 
}) => {
    const getStatusColor = () => {
        switch (status) {
            case 'success':
                return 'text-green-600 bg-green-50 border-green-200';
            case 'warning':
                return 'text-yellow-600 bg-yellow-50 border-yellow-200';
            case 'error':
                return 'text-red-600 bg-red-50 border-red-200';
            default:
                return 'text-gray-600 bg-gray-50 border-gray-200';
        }
    };

    const getStatusIcon = () => {
        switch (status) {
            case 'success':
                return (
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                );
            case 'warning':
                return (
                    <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                );
            case 'error':
                return (
                    <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                );
            default:
                return (
                    <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                );
        }
    };

    const displayValue = value !== null && value !== undefined ? value : 'N/A';

    return (
        <div className={`p-4 rounded-lg border ${getStatusColor()} transition-all duration-200 hover:shadow-md`}>
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-2">
                    {icon && <span className="text-gray-500">{icon}</span>}
                    <label className="text-sm font-medium text-gray-700">
                        {label}
                    </label>
                </div>
                {getStatusIcon()}
            </div>
            <div className="flex items-baseline space-x-1">
                <p className="text-lg font-semibold text-gray-900">
                    {displayValue}
                </p>
                {unit && (
                    <span className="text-sm text-gray-500">
                        {unit}
                    </span>
                )}
            </div>
        </div>
    );
};

export default DataValue; 